/* =========================================================================
   Ceramind Rib Preset Viewer — v1.0
   Theme asset. Upload to Online Store > Themes > Edit code > Assets.
   Pairs with: rib-viewer-block.liquid

   READ ONLY. Displays a stored rib design on a preset product page.
   Deliberately does NOT load or reuse the builder: the builder intercepts
   Add to Cart and blocks it until something has been drawn, which on a
   preset page would stop the product being bought at all.

   The curve maths below is copied from the builder so a preset renders
   byte-identically to the same design opened in the designer. If the
   builder's maths ever changes, change it here too.
   ========================================================================= */
(function(){
  if(window.__ceramindRibViewer) return;
  window.__ceramindRibViewer = true;

  var ROOT = document;

  // ---- canvas geometry (matches the builder) ----
  var AXIS_X = 55, AXIS_TOP = 40, AXIS_BOTTOM = 420;
  var CANVAS_H = AXIS_BOTTOM - AXIS_TOP;
  var PLOT_RIGHT = AXIS_X + CANVAS_H/2;
  var CORNER_R = 3;      // radius on the two backing-side corners, in mm

  var state = {
    design: null,        // the stored design, as saved by the builder
    totalHeight: 120,    // the height actually selected
    backingMm: 30
  };

  function clamp(v,min,max){ return Math.max(min,Math.min(max,v)); }
  function scale(){ return CANVAS_H/state.totalHeight; }
  function xRange(){ return state.totalHeight/2; }

  // ================= curve maths (mirrors the builder exactly) =============
  function unitDir(p1,p2){
    var dx=p2.x-p1.x, dy=p2.y-p1.y, L=Math.sqrt(dx*dx+dy*dy)||1;
    return {x:dx/L, y:dy/L};
  }
  function rotVec(v,a){
    var c=Math.cos(a), s=Math.sin(a);
    return {x:v.x*c - v.y*s, y:v.x*s + v.y*c};
  }
  function bulgeAngle(P, types, bulges, i){
    if(types[i] !== 'curve') return 0;
    var dx=P[i+1].x-P[i].x, dy=P[i+1].y-P[i].y;
    var L=Math.sqrt(dx*dx+dy*dy)||1;
    // Approaches 90 degrees but never reaches it. Past 90 the tangent points
    // back out of its own segment, the height bound collapses the handle at
    // the endpoint, and the curve snaps back mid-drag. Matches the previous
    // mapping to first order, so gentle curves are unchanged.
    // MUST match the designer, viewer, cart thumbnails, silhouette generator
    // and the SVG converter tool.
    return Math.atan2(3*(bulges[i]||0), L);
  }
  function chordDir(P,i){ return unitDir(P[i],P[i+1]); }
  function sharedTangent(P, types, bulges, k){
    var hasPrev = (k-1>=0 && types[k-1]==='curve');
    var hasNext = (k<types.length && types[k]==='curve');
    if(!(hasPrev && hasNext)) return null;
    var a = rotVec(chordDir(P,k-1), -bulgeAngle(P,types,bulges,k-1));
    var b = rotVec(chordDir(P,k),    bulgeAngle(P,types,bulges,k));
    var sx=a.x+b.x, sy=a.y+b.y, L=Math.sqrt(sx*sx+sy*sy);
    if(L<1e-6) return b;
    // NOTE: an earlier version nudged this tangent toward vertical at turning
    // points. Removed: any such correction must switch on somewhere, and a
    // switch is a discontinuity - the curve snapped while dragging. The
    // sideways bow limit handles overshoot instead, and varies continuously.
    return {x:sx/L, y:sy/L};
  }
  function fitFactor(S,D,h,xMin,xMax,yMin,yMax){
    var f=1;
    function lim(s,d,lo,hi){
      var m=d*h;
      if(m>1e-9){ var t=(hi-s)/m; if(t<f) f=t; }
      else if(m<-1e-9){ var t2=(lo-s)/m; if(t2<f) f=t2; }
    }
    lim(S.x,D.x,xMin,xMax); lim(S.y,D.y,yMin,yMax);
    return Math.max(0,Math.min(1,f));
  }
  // Only ever SHORTENS a handle - never redirects it, never crushes it to
  // nothing. Both change the drawn tangent at a node, which is a visible
  // sharp point. MUST match the designer, cart thumbnails, silhouette
  // generator and the SVG converter tool.
  var MIN_HANDLE = 0.08;
  function pickHandle(S,D,fallbackD,handle,xMin,xMax,yLo,yHi){
    var f = fitFactor(S,D,handle,xMin,xMax,yLo,yHi);
    return {D:D, f:Math.max(f, MIN_HANDLE)};
  }
  function controlPointsFor(P,types,bulges,i,xMin,xMax){
    var A=P[i], B=P[i+1];
    var dx=B.x-A.x, dy=B.y-A.y;
    var segLen=Math.sqrt(dx*dx+dy*dy)||1;
    var handle=segLen/3;
    var th=bulgeAngle(P,types,bulges,i);
    var localA=rotVec(chordDir(P,i),th), localB=rotVec(chordDir(P,i),-th);
    var tA=sharedTangent(P,types,bulges,i)   || localA;
    var tB=sharedTangent(P,types,bulges,i+1) || localB;
    var yLo=Math.min(A.y,B.y), yHi=Math.max(A.y,B.y);
    var hA=pickHandle(A,tA,localA,handle,xMin,xMax,yLo,yHi);
    var hB=pickHandle(B,{x:-tB.x,y:-tB.y},{x:-localB.x,y:-localB.y},handle,xMin,xMax,yLo,yHi);

    // Keep a segment from bowing sideways further than its own bulge asks
    // for. A shared tangent is set by the NEIGHBOURS, so a segment nobody
    // bulged can otherwise be dragged far outside its own two points.
    // Pure shortening, so the tangent and joint smoothness are unchanged.
    // MUST match the designer, cart thumbnails, silhouette generator and
    // the SVG converter tool.
    var allow = Math.max(Math.abs(bulges[i]||0), 4);
    var loX = Math.min(A.x,B.x)-allow, hiX = Math.max(A.x,B.x)+allow;
    function limitSideways(S,h){
      if(h.f<=0) return h;
      var reach=S.x+h.D.x*handle*h.f, f=h.f;
      if(reach>hiX && h.D.x>1e-9)       f=Math.min(f,(hiX-S.x)/(h.D.x*handle));
      else if(reach<loX && h.D.x<-1e-9) f=Math.min(f,(loX-S.x)/(h.D.x*handle));
      return {D:h.D, f:Math.max(0,f)};
    }
    hA=limitSideways(A,hA); hB=limitSideways(B,hB);

    return {A:A,B:B,
      C1:{x:A.x+hA.D.x*handle*hA.f, y:A.y+hA.D.y*handle*hA.f},
      C2:{x:B.x+hB.D.x*handle*hB.f, y:B.y+hB.D.y*handle*hB.f}};
  }

  // ================= scaled design =================
  // The stored design is scaled to whatever height the customer picked.
  // Each variant stores a design already drawn at that size's height, so
  // nothing is rescaled here. That is the point of the per-size files: what
  // is drawn is exactly what is stored, and exactly what is sent to the cart.
  function scaledNodes(){
    var d = state.design;
    if(!d || !d.nodes || d.nodes.length < 2) return null;
    // A variant's own design is already at the right height, so this factor is
    // 1 and nothing moves. The product-level fallback is one design at one
    // height, so it MUST be scaled - without this, a product with only a
    // master design shows the same height for every size.
    var f = (state.totalHeight && d.totalHeight) ? state.totalHeight/d.totalHeight : 1;
    var ns = d.nodes.map(function(n){ return {y:n.y*f, x:n.x*f}; });
    ns[0].y = 0;                              // pin the ends; float scaling drifts
    ns[ns.length-1].y = state.totalHeight;
    return {
      nodes: ns,
      types: d.types.slice(),
      bulges: (d.bulges||[]).map(function(b){ return b*f; })
    };
  }

  // Rib outline in real millimetres, y measured from the top downwards.
  // Returns SEGMENTS rather than a path string: the path has to be built in
  // canvas coordinates, because an arc's radius must be scaled along with its
  // endpoints. Transforming only the endpoints leaves the radius too small,
  // and SVG then inflates it to reach them - which bulges the corners.
  function ribGeometry(){
    var s = scaledNodes();
    if(!s) return null;
    var H = state.totalHeight;
    var P = s.nodes.map(function(n){ return {x:n.x, y:H-n.y}; });

    function bez(A,C1,C2,B,t){
      var mt=1-t;
      return {x: mt*mt*mt*A.x + 3*mt*mt*t*C1.x + 3*mt*t*t*C2.x + t*t*t*B.x,
              y: mt*mt*mt*A.y + 3*mt*mt*t*C1.y + 3*mt*t*t*C2.y + t*t*t*B.y};
    }

    var segs=[], maxX=0;
    for(var i=0;i<s.types.length;i++){
      var A=P[i], B=P[i+1];
      maxX=Math.max(maxX,A.x,B.x);
      if(s.types[i]!=='curve'){ segs.push({type:'line',A:A,B:B}); continue; }
      var cp=controlPointsFor(P,s.types,s.bulges,i,0,state.totalHeight/2);
      segs.push({type:'curve',A:A,B:B,C1:cp.C1,C2:cp.C2});
      for(var k=0;k<=24;k++){
        var p=bez(A,cp.C1,cp.C2,B,k/24);
        if(p.x>maxX) maxX=p.x;
      }
    }

    var backX = maxX + state.backingMm;
    var last=segs[segs.length-1].B, first=segs[0].A;
    return {
      segs: segs, maxX: maxX, backX: backX, H: H,
      topY: Math.min(last.y, first.y),
      botY: Math.max(last.y, first.y),
      endsAtTop: (last.y <= first.y),
      firstY: first.y, lastY: last.y
    };
  }

  // Build the closed outline directly in canvas coordinates, so the corner
  // radius scales with everything else.
  function ribPath(geo, X, Y, H){
    function f(v){ return Math.round(v*100)/100; }
    function px(mx,my){ return f(X(mx)) + ',' + f(Y(H - my)); }

    var d = 'M' + px(geo.segs[0].A.x, geo.segs[0].A.y);
    geo.segs.forEach(function(sg){
      if(sg.type==='line'){ d += ' L' + px(sg.B.x, sg.B.y); }
      else { d += ' C' + px(sg.C1.x,sg.C1.y) + ' ' + px(sg.C2.x,sg.C2.y) + ' ' + px(sg.B.x,sg.B.y); }
    });

    var r = CORNER_R;
    var rPx = f(Math.abs(X(r) - X(0)));      // the radius in canvas units
    if((geo.botY - geo.topY) > r*2 && state.backingMm > r){
      if(geo.endsAtTop){
        d += ' L' + px(geo.backX - r, geo.topY);
        d += ' A' + rPx + ',' + rPx + ' 0 0 1 ' + px(geo.backX, geo.topY + r);
        d += ' L' + px(geo.backX, geo.botY - r);
        d += ' A' + rPx + ',' + rPx + ' 0 0 1 ' + px(geo.backX - r, geo.botY);
      } else {
        d += ' L' + px(geo.backX - r, geo.botY);
        d += ' A' + rPx + ',' + rPx + ' 0 0 0 ' + px(geo.backX, geo.botY - r);
        d += ' L' + px(geo.backX, geo.topY + r);
        d += ' A' + rPx + ',' + rPx + ' 0 0 0 ' + px(geo.backX - r, geo.topY);
      }
      d += ' Z';
    } else {
      d += ' L' + px(geo.backX, geo.lastY) + ' L' + px(geo.backX, geo.firstY) + ' Z';
    }
    return d;
  }

  // ================= rendering =================
  function chooseStep(H){
    if(H<=60) return 5;
    if(H<=120) return 10;
    if(H<=180) return 20;
    return 25;
  }

  // Grid and axes are drawn deliberately: they let the customer judge the
  // real size of the rib as they change the height selection.
  //
  // The viewBox is sized to the actual drawing rather than fixed, because
  // the rib plus its backing is wider than the profile alone - a fixed box
  // either clips the backing or leaves the rib small in a sea of white.
  var LEFT_GUTTER = 52;    // room for the height labels
  var RIGHT_PAD   = 14;
  var BOTTOM_PAD  = 26;    // room for the width labels

  function renderCanvas(){
    var svg = ROOT.getElementById('ribViewCanvas');
    if(!svg) return;
    var geo = ribGeometry();
    if(!geo){ svg.innerHTML=''; return; }

    var H = geo.H, sc = scale(), parts = [];
    var step = chooseStep(H);
    var rightEdge = LEFT_GUTTER + geo.backX*sc;
    var vbW = rightEdge + RIGHT_PAD;
    var vbH = AXIS_BOTTOM + BOTTOM_PAD;
    svg.setAttribute('viewBox', '0 0 ' + Math.round(vbW) + ' ' + Math.round(vbH));

    function X(mm){ return LEFT_GUTTER + mm*sc; }
    function Y(mm){ return AXIS_BOTTOM - mm*sc; }

    // Horizontal rules across the full width of the rib, backing included.
    for(var y=0; y<=H; y+=1){
      var sy = Y(y), major = (y % step === 0);
      parts.push('<line x1="'+X(0)+'" y1="'+sy+'" x2="'+rightEdge+'" y2="'+sy+
                 '" stroke="'+(major?'#D2C1B4':'#E3E0DF')+'" stroke-width="'+(major?1:0.5)+'"/>');
      if(major && y>0 && y<H){
        parts.push('<line x1="'+(X(0)-4)+'" y1="'+sy+'" x2="'+X(0)+'" y2="'+sy+'" stroke="#A4886E" stroke-width="1"/>');
        parts.push('<text x="'+(X(0)-8)+'" y="'+(sy+4)+'" text-anchor="end" font-size="10" fill="#A4886E">'+y+'</text>');
      }
    }
    // Vertical rules across the whole width, so the ruler covers the backing too.
    for(var x=1; x<=geo.backX; x+=1){
      var sx = X(x), maj = (x % step === 0);
      parts.push('<line x1="'+sx+'" y1="'+Y(H)+'" x2="'+sx+'" y2="'+AXIS_BOTTOM+
                 '" stroke="'+(maj?'#D2C1B4':'#E3E0DF')+'" stroke-width="'+(maj?1:0.5)+'"/>');
      if(maj){
        parts.push('<line x1="'+sx+'" y1="'+AXIS_BOTTOM+'" x2="'+sx+'" y2="'+(AXIS_BOTTOM+5)+'" stroke="#A4886E" stroke-width="1"/>');
        parts.push('<text x="'+sx+'" y="'+(AXIS_BOTTOM+17)+'" text-anchor="middle" font-size="10" fill="#A4886E">'+x+'</text>');
      }
    }

    var pathD = ribPath(geo, X, Y, H);

    parts.push('<path d="'+pathD+'" fill="rgba(164,136,110,0.18)" stroke="#A4886E" stroke-width="2.5" stroke-linejoin="round"/>');
    parts.push('<line x1="'+X(0)+'" y1="'+AXIS_BOTTOM+'" x2="'+X(0)+'" y2="'+Y(H)+'" stroke="#A4886E" stroke-width="1.25"/>');
    parts.push('<text x="'+(X(0)-8)+'" y="'+(AXIS_BOTTOM+4)+'" text-anchor="end" font-size="11" fill="#473728">0</text>');
    parts.push('<text x="'+(X(0)-8)+'" y="'+(Y(H)+4)+'" text-anchor="end" font-size="11" fill="#473728">'+Math.round(H)+'</text>');

    svg.innerHTML = parts.join('');
  }

  function renderReadout(){
    var el = ROOT.getElementById('ribViewSpecs');
    if(!el) return;
    var geo = ribGeometry();
    if(!geo){ el.innerHTML=''; return; }
    el.innerHTML =
      '<span><strong>Height</strong> '+Math.round(state.totalHeight)+'mm</span>' +
      '<span><strong>Width</strong> '+Math.round(geo.backX)+'mm</span>' +
      '<span><strong>Backing</strong> '+Math.round(state.backingMm)+'mm</span>';
  }

  function render(){ renderCanvas(); renderReadout(); syncCartFields(); }

  // ================= variant / height wiring =================
  function productForm(){ return document.querySelector('form[action*="/cart/add"]'); }

  function sizeSelectEl(){
    return document.querySelector('select[name^="options"], select[name*="option"]');
  }
  function selectedSize(){
    var sel = sizeSelectEl();
    if(sel && sel.value) return String(sel.value).trim();
    var r = document.querySelectorAll('input[type="radio"][name*="option"]:checked');
    if(r.length) return String(r[0].value).trim();
    return null;
  }
  function selectedVariantId(){
    var f = productForm();
    if(!f) return null;
    var i = f.querySelector('input[name="id"], select[name="id"]');
    return i ? String(i.value) : null;
  }

  // Look up by SIZE NAME first. That is what the customer clicks and it is
  // read straight from the picker. Variant id is a fallback because it relies
  // on the theme keeping a hidden field in step, which it does not always do
  // promptly - which is why changing size appeared to do nothing.
  // Only this variant's OWN design, or null. The caller decides what to do
  // when there is none, because a variant design and the product-level
  // fallback need different handling: the first already carries its height,
  // the second has to be scaled to the size selected.
  function designForVariant(){
    var data = window.RIB_PRESET || {};
    var size = selectedSize();
    if(size && data.bySize && data.bySize[size]) return data.bySize[size];
    var id = selectedVariantId();
    if(id && data.variants && data.variants[id]) return data.variants[id];
    return null;
  }

  // Height and backing each size should have. Used only when falling back to
  // a product-level master design; a variant's own design carries its own.
  var SIZE_HEIGHT  = {'Micro':45, 'Small':80, 'Medium':115, 'Large':150, 'Extra Large':185};
  var SIZE_BACKING = {'Micro':30, 'Small':40, 'Medium':46, 'Large':52, 'Extra Large':58};

  function applyVariant(){
    var own = designForVariant();
    var d = own || (window.RIB_PRESET && window.RIB_PRESET.product) || null;
    state.design = d;
    if(own){
      state.totalHeight = (typeof d.totalHeight === 'number') ? d.totalHeight : 120;
      state.backingMm   = (typeof d.backing === 'number') ? d.backing : 30;
    } else if(d){
      var size = selectedSize();
      state.totalHeight = SIZE_HEIGHT[size]  || d.totalHeight || 120;
      state.backingMm   = SIZE_BACKING[size] || d.backing || 30;
    }
    render();
  }

  // ================= cart =================
  // Concept builds its cart request in JS and only sends fields it knows
  // about, so hidden inputs alone are ignored. The design has to be injected
  // into the outgoing request itself.
  function orderedDesign(){
    var s = scaledNodes();
    if(!s) return null;
    return {
      totalHeight: Math.round(state.totalHeight),
      units: 'mm',
      nodes: s.nodes.map(function(n){ return {y: Math.round(n.y*100)/100, x: Math.round(n.x*100)/100}; }),
      types: s.types,
      bulges: s.bulges.map(function(b){ return Math.round(b*100)/100; }),
      backing: Math.round(state.backingMm),
      hole: null
    };
  }

  function syncCartFields(){
    var f = productForm();
    if(!f) return;
    var d = orderedDesign();
    if(!d) return;
    function ensure(name){
      var el = f.querySelector('input[name="'+name+'"]');
      if(!el){
        el = document.createElement('input');
        el.type = 'hidden'; el.name = name;
        f.appendChild(el);
      }
      return el;
    }
    ensure('properties[_rib_profile]').value = JSON.stringify(d);
    ensure('properties[Height]').value = Math.round(state.totalHeight) + 'mm';
  }

  function injectProps(body){
    var d = orderedDesign();
    if(!d) return body;
    var props = {
      '_rib_profile': JSON.stringify(d),
      'Height': Math.round(state.totalHeight) + 'mm'
    };
    var k;
    if(body instanceof FormData){
      for(k in props) body.set('properties['+k+']', props[k]);
      return body;
    }
    if(body instanceof URLSearchParams){
      for(k in props) body.set('properties['+k+']', props[k]);
      return body;
    }
    if(typeof body === 'string'){
      try {
        var obj = JSON.parse(body);
        if(obj && typeof obj === 'object'){
          if(Array.isArray(obj.items)){
            obj.items.forEach(function(it){
              it.properties = Object.assign({}, it.properties || {}, props);
            });
          } else {
            obj.properties = Object.assign({}, obj.properties || {}, props);
          }
          return JSON.stringify(obj);
        }
      } catch(e){
        var usp = new URLSearchParams(body);
        for(k in props) usp.set('properties['+k+']', props[k]);
        return usp.toString();
      }
    }
    return body;
  }

  function hookCart(){
    var realFetch = window.fetch;
    if(realFetch){
      window.fetch = function(url, opts){
        var u = String(url && url.url ? url.url : url);
        if(u.indexOf('/cart/add') !== -1 && opts && opts.body){
          try { opts = Object.assign({}, opts, {body: injectProps(opts.body)}); } catch(e){}
        }
        return realFetch.apply(this, arguments);
      };
    }
    var XHR = window.XMLHttpRequest;
    if(XHR && XHR.prototype && XHR.prototype.send){
      var ro = XHR.prototype.open, rs = XHR.prototype.send;
      XHR.prototype.open = function(m,u){ this.__ribAdd = String(u).indexOf('/cart/add') !== -1; return ro.apply(this, arguments); };
      XHR.prototype.send = function(b){
        if(this.__ribAdd && b){ try { b = injectProps(b); } catch(e){} }
        return rs.call(this, b);
      };
    }
    var f = productForm();
    if(f) f.addEventListener('submit', syncCartFields, true);
  }

  // ================= customise handoff =================
  // The design is handed over in sessionStorage rather than the URL: designs
  // run to several thousand characters, which is past what a URL can carry
  // safely once encoded.
  function wireCustomise(){
    var btn = ROOT.getElementById('ribCustomiseBtn');
    if(!btn) return;
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var d = orderedDesign();
      if(!d) return;
      try {
        sessionStorage.setItem('ceramind_rib_handoff', JSON.stringify({
          design: d,
          height: Math.round(state.totalHeight),
          size: selectedSize(),
          from: (window.RIB_PRESET && window.RIB_PRESET.title) || ''
        }));
      } catch(err){}
      var url = btn.getAttribute('data-url') || '/products/custom-throwing-rib';
      window.location.href = url + (url.indexOf('?')===-1 ? '?' : '&') + 'from=preset';
    });
  }

  // ================= boot =================
  function watchVariant(){
    var last = selectedSize() + '|' + selectedVariantId();
    function sync(){
      var now = selectedSize() + '|' + selectedVariantId();
      if(now === last) return;
      last = now;
      applyVariant();            // size changed: load that size's own design
    }
    // Several routes, because themes announce a variant change differently and
    // a missed one leaves the drawing showing the wrong size.
    ['change','input'].forEach(function(t){
      document.addEventListener(t, function(){ setTimeout(sync, 40); }, true);
    });
    document.addEventListener('click', function(){ setTimeout(sync, 120); }, true);
    var sel = sizeSelectEl();
    if(sel && window.MutationObserver){
      new MutationObserver(sync).observe(sel, {attributes:true, childList:true, subtree:true});
    }
    setInterval(sync, 300);
  }

  // Drive the theme's own size picker. The select may sit outside the form and
  // can be wrapped by a custom element with its own value setter, so set
  // through the native descriptor and fire events on both.
  function selectSizeVariant(size, attempt){
    attempt = attempt || 0;
    var sel = sizeSelectEl();
    if(!sel){
      if(attempt < 20) setTimeout(function(){ selectSizeVariant(size, attempt+1); }, 100);
      return false;
    }
    var idx = -1;
    for(var i=0;i<sel.options.length;i++){
      var v = (sel.options[i].value||'').trim(), t = (sel.options[i].textContent||'').trim();
      if(v === size || t === size){ idx = i; break; }
    }
    if(idx === -1 || sel.selectedIndex === idx) return idx !== -1;
    try {
      var proto = window.HTMLSelectElement && window.HTMLSelectElement.prototype;
      var desc = proto && Object.getOwnPropertyDescriptor(proto, 'value');
      if(desc && desc.set) desc.set.call(sel, sel.options[idx].value);
      else sel.value = sel.options[idx].value;
    } catch(e){ sel.value = sel.options[idx].value; }
    sel.selectedIndex = idx;
    ['input','change'].forEach(function(t){
      try { sel.dispatchEvent(new Event(t, {bubbles:true})); } catch(e){}
    });
    var host = sel.closest ? sel.closest('custom-select, variant-selects, variant-radios, .product-form, [is]') : null;
    if(host && host !== sel){
      ['input','change'].forEach(function(t){
        try { host.dispatchEvent(new Event(t, {bubbles:true})); } catch(e){}
      });
    }
    return true;
  }

  function boot(){
    var host = ROOT.getElementById('ribViewRoot');
    if(!host) return;
    if(!window.RIB_PRESET || (!window.RIB_PRESET.product && !window.RIB_PRESET.variants)){
      host.style.display = 'none';   // no design stored: show nothing at all
      return;
    }
    // Open on Medium rather than whichever variant the theme happens to
    // default to, which is usually the first and so the smallest.
    var DEFAULT_SIZE = 'Medium';
    if(selectedSize() !== DEFAULT_SIZE && selectSizeVariant(DEFAULT_SIZE)){
      setTimeout(applyVariant, 250);
    }
    applyVariant();
    watchVariant();
    hookCart();
    wireCustomise();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Read-only introspection hook for automated testing.
  window.__getViewerState = function(){
    var geo = ribGeometry();
    return {
      height: state.totalHeight,
      backing: state.backingMm,
      hasDesign: !!state.design,
      nodes: state.design ? state.design.nodes.length : 0,
      backX: geo ? Math.round(geo.backX*100)/100 : null,
      size: selectedSize(),
      variantId: selectedVariantId()
    };
  };
})();